module.exports = __webpack_public_path__ + "img/catseye04.2e0ba5d2.jpg";